import type { WeaponDef, WeaponKind } from '@nebulark/engine';

export const WEAPONS: Record<WeaponKind, WeaponDef> = {
  spread: {
    kind: 'spread',
    levels: [
      { fireRateHz: 6,  bulletSpeed: 600, damage: 1, spreadDeg: 0,  bulletsPerShot: 1 },
      { fireRateHz: 7,  bulletSpeed: 600, damage: 1, spreadDeg: 18, bulletsPerShot: 3 },
      { fireRateHz: 8,  bulletSpeed: 650, damage: 1, spreadDeg: 28, bulletsPerShot: 5 },
    ],
  },
  laser: {
    kind: 'laser',
    levels: [
      { fireRateHz: 4, bulletSpeed: 380, damage: 2, pierce: 1 },
      { fireRateHz: 5, bulletSpeed: 420, damage: 3, pierce: 2 },
      { fireRateHz: 6, bulletSpeed: 460, damage: 4, pierce: 3 },
    ],
  },
  homing: {
    kind: 'homing',
    levels: [
      { fireRateHz: 3, bulletSpeed: 450, damage: 2, homingTurnDegPerSec: 180 },
      { fireRateHz: 4, bulletSpeed: 500, damage: 2, homingTurnDegPerSec: 240 },
      { fireRateHz: 5, bulletSpeed: 550, damage: 3, homingTurnDegPerSec: 300 },
    ],
  },
};
